import Active from './Active';
import Aligned from './Aligned';
import Brand from './Brand';
import Default from './Default';
import FileType from './FileType';
import Filled from './Filled';
import RichTextEditor from './RichTextEditor';
const Icons = {
    // Icons with active boolean state
    ...Active,
    // Icons with alignment prop (ex. chevron with top, bottom)
    ...Aligned,
    // Brand logos used to represent companies or platforms (e.g. Google, Meta, Microsoft)
    ...Brand,
    // Static icons with no additional props
    ...Default,
    // Icons with filled boolean state
    ...Filled,
    // Rich text editor action icons
    ...RichTextEditor,
    // File type icons
    ...FileType,
};
export { Active, Aligned, Brand, Default, Filled, RichTextEditor, FileType };
export default Icons;
